import { render, staticRenderFns } from "./group-not-app.vue?vue&type=template&id=40499266&scoped=true&"
import script from "./group-not-app.vue?vue&type=script&lang=js&"
export * from "./group-not-app.vue?vue&type=script&lang=js&"
import style0 from "./group-not-app.vue?vue&type=style&index=0&id=40499266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40499266",
  null
  
)

export default component.exports